import * as React from 'react';

/*
 * SettingsCard — the card-per-setting grammar (mock: org-settings.html,
 * ref: Visitors account page). Title + one-line description + control,
 * and a sunk footer with the constraint on the left and the action on
 * the right. The settings archetype for /v2/org and /v2/admin.
 */

export default function SettingsCard({
    title,
    desc,
    foot,
    children,
}: {
    title: string;
    desc?: React.ReactNode;
    /* footer content — typically <span className="hint">…</span> + a
       button; omitted for read-only cards */
    foot?: React.ReactNode;
    children?: React.ReactNode;
}) {
    return (
        <section className="mb-6 overflow-hidden rounded-[16px] border border-border">
            <div className="px-6 py-5">
                <h3 className="text-[15px] font-semibold leading-tight">
                    {title}
                </h3>
                {desc && (
                    <p className="mt-1 max-w-[56ch] text-[12.5px] text-faint">
                        {desc}
                    </p>
                )}
                {children && <div className="mt-4">{children}</div>}
            </div>
            {foot && (
                <div className="flex items-center gap-3 border-t border-line bg-sunk px-6 py-3">
                    {foot}
                </div>
            )}
        </section>
    );
}
